var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSunRays = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sun") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP_Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-172.000000, -1458.000000)",
    fill: "#D1D3D4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1438.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sun",
    transform: "translate(172.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    cx: 16,
    cy: 16,
    r: 7.74193548
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    x: 14.4516129,
    y: 0,
    width: 3.09677419,
    height: 6.19354839,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy",
    transform: "translate(24.962044, 6.381399) rotate(-315.000000) translate(-24.962044, -6.381399) ",
    x: 23.4136573,
    y: 3.28462505,
    width: 3.09677419,
    height: 6.19354839,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy-2",
    transform: "translate(28.903226, 16.000000) rotate(-270.000000) translate(-28.903226, -16.000000) ",
    x: 27.3548387,
    y: 12.9032258,
    width: 3.09677419,
    height: 6.19354839,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy-3",
    transform: "translate(24.962044, 24.962044) rotate(-225.000000) translate(-24.962044, -24.962044) ",
    x: 23.4136573,
    y: 21.8652702,
    width: 3.09677419,
    height: 6.19354839,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy-4",
    transform: "translate(16.000000, 28.903226) rotate(-180.000000) translate(-16.000000, -28.903226) ",
    x: 14.4516129,
    y: 25.8064516,
    width: 3.09677419,
    height: 6.19354839,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy-5",
    transform: "translate(6.381399, 24.962044) rotate(-135.000000) translate(-6.381399, -24.962044) ",
    x: 4.83301214,
    y: 21.8652702,
    width: 3.09677419,
    height: 6.19354839,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy-6",
    transform: "translate(3.096774, 16.000000) rotate(-90.000000) translate(-3.096774, -16.000000) ",
    x: 1.5483871,
    y: 12.9032258,
    width: 3.09677419,
    height: 6.19354839,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy-7",
    transform: "translate(6.381399, 6.381399) rotate(-45.000000) translate(-6.381399, -6.381399) ",
    x: 4.83301214,
    y: 3.28462505,
    width: 3.09677419,
    height: 6.19354839,
    rx: 1.5
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSunRays);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sun_rays.fd5e037eebf81da133eeb500b2104759.svg";